import React from 'react';
import { useLang } from '../context/LanguageContext';
import { growthCopy } from '../data/growth-copy';
import { GrowthHero } from '../components/growth/GrowthHero';
import { GrowthFlow } from '../components/growth/GrowthFlow';
import { GrowthIntelligence } from '../components/growth/GrowthIntelligence';
import { GrowthServices } from '../components/growth/GrowthServices';
import { GrowthClosing } from '../components/growth/GrowthClosing';
import { LivePlayground } from '../components/experience/LivePlayground';
import '../styles/growth.css';

export default function Home() {
  const { lang } = useLang(), copy = growthCopy[lang];
  return <div className="growth-page">
    <GrowthHero copy={copy} />
    <GrowthFlow copy={copy} />
    <GrowthIntelligence copy={copy} lang={lang} />
    <LivePlayground />
    <GrowthServices copy={copy} />
    <GrowthClosing copy={copy} />
  </div>;
}